class Config {
  static REACT_APP_API_ENTRYPOINT = window.chicagoEnv.REACT_APP_API_ENTRYPOINT;
  static REACT_APP_API_URL = window.chicagoEnv.REACT_APP_API_URL;
}

export default Config;
